// Utils
import { createTimestamp } from '../../common/uid/timestamp';
import { getTimestamp } from '../../common/utils/timeUtil';
import randomString from '../../common/uid/randomString';

const SESSION_ID_LOCAL_STORAGE_KEY = 'msid';

let cachedSessionId;

const createSessionId = () => `msid-${createTimestamp(getTimestamp())}${randomString(5)}`;

/**
 * NOTE: The electron main process doesn't have access to the session storage API, so this will
 * cause a new session ID every time it's quit and re-opened.
 * The main window will have a different session ID to the main window, as well, but won't
 * likely be used as it's the main process that attaches the session ID to the events.
 */
const storeSessionId = (sessionId) => {
    cachedSessionId = sessionId;

    if (global.sessionStorage) {
        global.sessionStorage.setItem(SESSION_ID_LOCAL_STORAGE_KEY, sessionId);
    }

    return cachedSessionId;
};

const retrieveSessionId = () => {
    if (cachedSessionId) return cachedSessionId;

    if (global.sessionStorage) return global.sessionStorage.getItem(SESSION_ID_LOCAL_STORAGE_KEY);
};

export const getSessionId = () => {
    const persistedDeviceId = retrieveSessionId();

    if (persistedDeviceId) return persistedDeviceId;

    const sessionId = createSessionId();
    storeSessionId(sessionId);

    return sessionId;
};
